import {
    RxJsonSchema
} from 'rxdb';
import { PathWaypoint } from '../models/path-waypoint';
import { PathWaypointDoc } from '../services';

export const pathWaypointMigrations = {
    1: function(doc) { 
        return doc 
    } 
}

export const pathWaypointSchema: RxJsonSchema<PathWaypoint> = {
    title: 'path waypoint schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true
        },
        pathId: {
            type: 'string'
        },
        pointId: {
            type: ['string', 'null']
        },
        fromPointId: {
            type: ['string', 'null']
        },
        waypointOrder: {
            type: 'number'
        },
        segment: {
            type: 'string'
        },
        type : {
            type: 'string'
        },
        updatedAt: { 
            type: 'number' 
        }
    },
    required: ['_id', 'pathId' ],
    indexes: [ '_id', 'pathId', 'waypointOrder', 'updatedAt']
    //refine indexes when schema changes (not worth having prod clients rebuild db just for new index)
    //indexes: [ 'pathId', ['pathId','pointId'], ['pathId','type'],'updatedAt']
};

export const pathWaypointPullQueryBuilder = () => {    
    
    return (doc) => {
        if (!doc) {
            doc = {
                _id: '',
                pathId: '',
                pointId: '',
                fromPointId:'',
                waypointOrder:'',
                segment:'',
                type:'',
                updatedAt:0
            };
        }

        const query = 
          `{
            feedForRxdbPathWaypoints(lastId: "${doc._id}", minUpdatedAt: ${doc.updatedAt} ) {
                _id
                pathId
                pointId
                fromPointId
                waypointOrder
                segment
                type
                updatedAt
                deleted
                _rev
            }
        }`;
        return {
            query,
            variables: {}
        };
    }
};
